module.exports = __webpack_public_path__ + "static/media/stop-3.d12c45a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-3.svg
// module id = 1348
// module chunks = 0